import { LoadingSpinnerIconTwoTone } from '@room-match/shared-ui-components';
import React from 'react';

const LoadingCont = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '50%' }}>
      <LoadingSpinnerIconTwoTone style={{ width: 100, height: 100 }} />
    </div>
  );
};

export default LoadingCont;
